import { Fetch } from "./util/InterceptedFetch";
import { BuildUri } from "./util/BuildUri";

import { AuthRequest, ChangePasswordRequest } from "../requests/AuthRequests";

export interface TokenResponse {
    token: string;
}

export class AuthEndpoints {
    private fetch: Fetch | null = null;

    getToken(request: AuthRequest): Promise<TokenResponse> {
        return new Promise((resolve, reject) => {
            fetch(BuildUri("/authentication/login"), {
                cache: "no-cache",
                method: "POST",
                body: JSON.stringify(request),
                headers: {
                    "content-type": "application/json"
                },
                mode: "cors",
                referrer: "no-referrer"
            })
                .then((response: Response) => {
                    const contentType = response.headers.get("content-type");
                    if (contentType === "application/json") {
                        if (response.ok) {
                            response.json().then(r => resolve(r));
                        } else {
                            response.json().then(r => reject(r));
                        }
                    } else {
                        response.text().then(r => reject(r));
                    }
                })
                .catch(err => reject(err));
        });
    }

    changePassword(changePasswordRequest: ChangePasswordRequest): Promise<TokenResponse> {
        if (!this.fetch) {
            throw new Error("AuthEndpoint is missing this.fetch");
        }
        return this.fetch(BuildUri("/authentication/change-password"), { method: "POST", body: changePasswordRequest });
    }

    setInterceptedFetch(fetch: Fetch) {
        this.fetch = fetch;
    }
}



// WEBPACK FOOTER //
// ./src/endpoints/AuthEndpoints.ts